import { authAxios } from './CustomAxios';

class AuthApi {
    getAccessToken = async (): Promise<string> => {
        const response = await authAxios.get<string>('/auth/access-token');
        return response.data;
    };

    createAccessToken = async (workDocsAccessToken?: string): Promise<string> => {
        const response = await authAxios.post<string>('/auth/access-token', workDocsAccessToken);
        return response.data;
    };

    logOut = async () => {
        await authAxios.get('/logout');
    };
}

const authApi: AuthApi = new AuthApi();
export default authApi;
